
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { DialogBoxComponent } from './dialog-box.component';



@NgModule({
  declarations: [
    DialogBoxComponent,
  ],

  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
  ],

  exports: [
    DialogBoxComponent,
  ],

  providers: [ ],

})

export class DialogBoxModule { }
